import { ICellRendererParams } from 'ag-grid-community';

import { TextLines } from 'core/elements';
import { getAgGridTableCellData } from 'core/utils';
import { QuotePartColId } from 'quotes/components/QuotePartList';
import { QuoteEntityType } from 'quotes/enums';
import { QuotePartHelper } from 'quotes/helpers';
import { Color } from 'theme/enums';

interface IProps extends ICellRendererParams {
  quoteEntityType?: QuoteEntityType;
}

const ValidityErrorCell = ({ quoteEntityType = QuoteEntityType.QUOTE, ...props }: IProps) => {
  const data = getAgGridTableCellData(props, QuotePartColId.VALIDATION_ERRORS);
  if (!data) {
    return props?.value;
  }

  return (
    <TextLines
      texts={QuotePartHelper.validationErrors({ data, filteredByStatuses: false, quoteEntityType })}
      color={Color.DANGER}
      isSubText
    />
  );
};

export default ValidityErrorCell;
